import { BlogWrapper } from "../../../../src/collections/blog/Blog.style.js";
import Profile from "../../../../src/collections/blog/2022/2022-01-14-open-source-journey-gaurav-chadha/Intern-profile.webp";
import * as React from 'react';
export default {
  BlogWrapper,
  Profile,
  React
};